module.exports = {
	interiorData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV': {
					Image: require('./../assets/360/Interiors/Hibrida.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.474 1.694',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La Nueva Escape ostenta un tablero de instrumentos de 12.3' a color completamente digital y personalizable, permitiéndote visualizar toda la información de la computadora de viaje, el comportamiento del sistema de motorización híbrido y la regeneración de energía, las asistencias al conductor y mucho más. Disponible en la versión Titanium. Imagen de referencia. El panel central del vehículo que se comercializa en Colombia es de color carbón.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.878 -2.016 0.335',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Nueva transmisión automática de 8 velocidades, controlada a través de un sofisticado selector de marchas giratorio que reemplaza la tradicional palanca de cambios, brindando así mayor amplitud y sofisticación en el habitáculo.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '3.872 3.234 0.693',
							Rotation: '54.149 -90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel de la versión Titanium genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 1.188 1.205',
							Rotation: '0 90 0',
							Scale: '0.08 0.08',
							Type: "INTERIOR",
							Text: 'Pantalla de visualización frontal, también conocida como Head-Up Display, te permitirá mantener los ojos en el camino y las manos en el volante en todo momento. Esta pantalla te brindará información de llamadas, GPS y algunas asistencias al conductor directamente en frente tuyo. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 0.788 -0.025',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La cámara de reversa de la versión Titanium te permitirá visualizar todo lo que se encuentra detrás del vehículo en la pantalla de 8' de la Nueva Escape. El sistema muestra líneas virtuales para ayudarte a estacionar en espacios pequeños. Imagen de referencia. El vehículo que se comercializa en Colombia cuenta con panel central en color carbón y el tipo de puerto USB puede variar.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'MUSTANG MACH 1': {
					Image: require('./../assets/360/Interiors/13-MustangMach1.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-3.338 0.713 2.071',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El Mustang Mach 1 viene equipado con un impresionante tablero de instrumentos que incorpora una pantalla LCD totalmente digital de 12.3 pulgadas. Este panel de instrumentos personalizable, fue diseñado para ayudarte a sacar el máximo partido de cada experiencia de conducción, te mostrará información optimizada según el modo de conducción seleccionado. Su configuración cambiará automáticamente según el modo de conducción y con la función MyColor®  se puede programar para mostrar distintos indicadores en varias opciones de color disponibles o puedes crear tu propia configuración.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.917 0.220 1.970',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El volánte térmico de tu Mustang Mach 1 viene forrado en cuero con controles de audio y SYNC®',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 -1.156 0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Esto es lo mejor en control cuando se trata de personalizar la experiencia de manejo en tu Mustang Mach 1. Los cinco modos de manejo: normal, Nieve/Mojado, Deportivo, Pista o Pista de Carrera (cuarto de milla) te permiten seleccionar la dinámica que deseas. Cada modo establece el esfuerzo de dirección, la respuesta del acelerador, el control de estabilidad electrónico, entre otros, para ajustarlos al modo seleccionado. Lo único que tienes que hacer es activar el interruptor en la consola central para obtener lo que quieres. Con MyMode guardarás tus ajustes preferidos, incluida la intensidad del escape de válvulas activas tu Mach 1.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 0.211 0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El sistema de conectividad SYNC® 3 permite lograr una integración absoluta entre el vehículo y el conductor. A través de comandos de voz es posible controlar de manera intuitiva el teléfono y controlar el sistema de entretenimiento en general. Además, con SYNC® 3 puedes usar tu celular de forma más segura e inteligente mientras conduces. Varias funciones y aplicaciones de tu celular, incluyendo Waze, aparecerán en la pantalla táctil de 8" de tu  Mustang Mach 1 gracias a Apple CarPlay® y Android Auto®. La activación del sistema de navegación Waze depende de la marca/versión de tu teléfono celular.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '0.722 -0.015 2.185',
							Rotation: '0 -90 0',
							Scale: '0.15 0.15',
							Type: "INTERIOR",
							Text: 'El interior del Mustang Mach 1 trae asientos delanteros de color negro ébano con una franja decorativa heredada del Mach 1. Así mismo, equipan un control de temperatura (Calefacción/Refrigeración). Y los protectores de estribo de las puertas delanteras llevan un emblema de Mach 1 iluminado.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 04.webp'),
						},
					],
				},
				'MUSTANG GT PREMIUM': {
					Image: require('./../assets/360/Interiors/14-MustangGTPremium.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 -1.047 0.320',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Interior inspirado en los aviones de guerra, incorpora 4 botones que te permitirán, encender las luces de parqueo, desactivar el control de tracción, seleccionar el modo de dirección deseado y escoger el modo de conducción que quieras.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.917 0.474 1.694',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Tu Mustang GT Premium viene equipado con un impresionante Tablero de Instrumentos que incorpora una pantalla LCD digital de 12” con MyColor®.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 -2.016 -0.022',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Tu Ford Mustang GT Premium viene equipado con una caja automática de 10 velocidades que permite obtener cambios de marcha rápidos y precisos e incorpora levas en el volante para aquellos amantes del control. Esta es la mejor caja automática de todos los Mustang.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 0.288 -2.540',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Pensando en la seguridad tuya y de tu familia, incluímos 8 airbags que dan tranquilidad a la hora de conducir. Tu Mustang GT Premium se destaca en seguridad, con sus airbags frontales y de rodilla para conductor y pasajero delantero, airbags de cortina y laterales de tórax.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '0.722 -0.015 2.185',
							Rotation: '0 -90 0',
							Scale: '0.15 0.15',
							Type: "INTERIOR",
							Text: 'Asientos Delanteros tapizados en cuero con Control de Temperatura (Calefacción/Refrigeración). ',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'ESCAPE ECOBOOST': {
					Image: require('./../assets/360/Interiors/Hibrida.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.474 1.694',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La Nueva Escape ostenta un tablero de instrumentos de 12.3' a color completamente digital y personalizable, permitiéndote visualizar toda la información de la computadora de viaje, el comportamiento del sistema de motorización híbrido y la regeneración de energía, las asistencias al conductor y mucho más. Disponible en la versión Titanium. Imagen de referencia. El panel central del vehículo que se comercializa en Colombia es de color carbón.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.878 -2.016 0.335',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Nueva transmisión automática de 8 velocidades, controlada a través de un sofisticado selector de marchas giratorio que reemplaza la tradicional palanca de cambios, brindando así mayor amplitud y sofisticación en el habitáculo.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '3.872 3.234 0.693',
							Rotation: '54.149 -90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel de la versión Titanium genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 1.188 1.205',
							Rotation: '0 90 0',
							Scale: '0.08 0.08',
							Type: "INTERIOR",
							Text: 'Pantalla de visualización frontal, también conocida como Head-Up Display, te permitirá mantener los ojos en el camino y las manos en el volante en todo momento. Esta pantalla te brindará información de llamadas, GPS y algunas asistencias al conductor directamente en frente tuyo. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 0.788 -0.025',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La cámara de reversa de la versión Titanium te permitirá visualizar todo lo que se encuentra detrás del vehículo en la pantalla de 8' de la Nueva Escape. El sistema muestra líneas virtuales para ayudarte a estacionar en espacios pequeños. Imagen de referencia. El vehículo que se comercializa en Colombia cuenta con panel central en color carbón y el tipo de puerto USB puede variar.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'ESCAPE SE 4X2 FHEV': {
					Image: require('./../assets/360/Interiors/2-EscapeSE4x2-HEV.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.665 -0.422',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'SYNC 3.4 con pantalla táctil. A tráves de sencillos comandos de voz, el sistema de conectividad SYNC 3.4 te permitirá controlar tu música y realizar llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil multi-capacitiva de 8 pulgadas y un sistema de audio premium Bang & Olufsen con 10 parlantes (incluyendo subwoofer). ',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.878 0.329 1.860',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Nueva Escape ostenta un tablero de instrumentos de 12.3´ a color completamente digital y personalizable, permitiéndote visualizar toda la información de la computadora de viaje, el comportamiento del sistema de motorización híbrido y la regeneración de energía, las asistencias al conductor y mucho más. *Imagen de referencia. El panel central del vehículo que se comercializa en Colombia es de color carbón.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 -1.044 -0.035',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El climatizador electrónico de dos zonas permite controlar la calefacción y ventilación, indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor y el pasajero delantero.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 0.665 0.348',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La cámara de reversa te permitirá visualizar todo lo que se encuentra detrás del vehículo en la pantalla de 8´ de la Nueva Escape. El sistema muestra líneas virtuales para ayudarte a estacionar en espacios pequeños. *Imagen de referencia. El vehículo que se comercializa en Colombia cuenta con panel central en color carbón y el tipo de puerto USB puede variar.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 0.320 -1.914',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Pensando en la seguridad tuya y de tu familia, incluimos 9 airbags que dan tranquilidad a la hora de conducir. La Nueva Escape se destaca en seguridad con sus airbags frontales y laterales para conductor y pasajero, de rodilla para conductor, de cortina y laterales en las plazas traseras.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '-2.917 0.329 -0.035',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La cámara de reversa de la versión Titanium te permitirá visualizar todo lo que se encuentra detrás del vehículo en la pantalla de 8' de la Nueva Escape. El sistema muestra líneas virtuales para ayudarte a estacionar en espacios pequeños. Imagen de referencia. El vehículo que se comercializa en Colombia cuenta con panel central en color carbón y el tipo de puerto USB puede variar.",
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV': {
					Image: require('./../assets/360/Interiors/03-EscapeSEL4x2-HEV.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.665 -0.422',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'SYNC 3.4 con pantalla táctil. A tráves de sencillos comandos de voz, el sistema de conectividad SYNC 3.4 te permitirá controlar tu música y realizar llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil multi-capacitiva de 8 pulgadas y un sistema de audio premium Bang & Olufsen con 10 parlantes (incluyendo subwoofer). ',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.878 0.329 1.860',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Nueva Escape ostenta un tablero de instrumentos de 12.3´ a color completamente digital y personalizable, permitiéndote visualizar toda la información de la computadora de viaje, el comportamiento del sistema de motorización híbrido y la regeneración de energía, las asistencias al conductor y mucho más. *Imagen de referencia. El panel central del vehículo que se comercializa en Colombia es de color carbón.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '2.394 2.733 -0.035',
							Rotation: '-45 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Techo panorámico de doble panel. La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel de las versiones SEL y Titanium genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre. *Imágenes de referencia de la versión Titanium. La versión Titanium comercializada en Colombia cuenta con una parrilla frontal con barras cromadas y un diseño de rines diferente. Las características varían en función de la versión. Ver sección de versiones y especificaciones técnicas. ',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 0.665 0.348',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La cámara de reversa te permitirá visualizar todo lo que se encuentra detrás del vehículo en la pantalla de 8´ de la Nueva Escape. El sistema muestra líneas virtuales para ayudarte a estacionar en espacios pequeños. *Imagen de referencia. El vehículo que se comercializa en Colombia cuenta con panel central en color carbón y el tipo de puerto USB puede variar.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 -1.044 -0.035',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El climatizador electrónico de dos zonas permite controlar la calefacción y ventilación, indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor y el pasajero delantero.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '-2.917 0.329 -0.035',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La cámara de reversa de la versión Titanium te permitirá visualizar todo lo que se encuentra detrás del vehículo en la pantalla de 8' de la Nueva Escape. El sistema muestra líneas virtuales para ayudarte a estacionar en espacios pequeños. Imagen de referencia. El vehículo que se comercializa en Colombia cuenta con panel central en color carbón y el tipo de puerto USB puede variar.",
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/BUllet 08.webp'),
						},
					],
				},
				'BRONCO SPORT WILDTRAK': {
					Image: require('./../assets/360/Interiors/05-BroncoSport-WT.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '2.327 -0.450 -0.422',
							Rotation: '-80.797 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Almacenamiento Inteligente. Si necesitas más espacio de almacenamiento, la versión Wildtrak ofrece espacio adicional debajo de los asientos de la segunda fila. Los asientos se levantan y te ofrecen un lugar para guardar herramientas o elementos pequeños.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet1.webp'),
						},
						{
							Position: '-2.878 0.329 -2.190',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '9 Airbags pensados en la seguridad tuya y la de todos los pasajeros, incluimos 9 airbags que dan tranquilidad a la hora de conducir. La Nueva Bronco Sport 4x4 se destaca en seguridad con sus airbags frontales y laterales para conductor y pasajero, de rodilla para conductor, de cortina y laterales en las plazas traseras.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet2.webp'),
						},
						{
							Position: '1.526 -0.353 -3.119',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asientos para tu comodidad. En la Nueva Bronco Sport 4x4 el placer de conducir es único. Además del sistema de calefacción en los asientos delanteros, la plaza del conductor posee ajuste eléctrico. *Disponible en la versión Wildtrak 4x4.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet3.webp'),
						},
						{
							Position: '-2.917 0.088 0.071',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'SYNC 3.4 con pantalla táctil. A través de sencillos comandos de voz, el sistema de conectividad SYNC 3.4 te permitirá controlar tu música y realizar llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil multi-capacitiva de  8 pulgadas y un sistema de audio premium Bang & Olufsen con 10 parlantes en la versión Wildtrak 4x4. ',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet4.webp'),
						},
						{
							Position: '-2.917 0.088 2.054',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Pantalla de productividad. La Nueva Bronco Sport 4x4 ostenta una pantalla de productividad de 6.5' en el tablero de instrumentos, permitiéndote visualizar toda la información de la computadora de viaje y más.",
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet5.webp'),
						},
					],
				},
				'BRONCO SPORT BIG BEND': {
					Image: require('./../assets/360/Interiors/6-BroncoSportBB.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '2.327 -0.450 -0.422',
							Rotation: '-80.797 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Almacenamiento Inteligente. Si necesitas más espacio de almacenamiento, la versión Wildtrak ofrece espacio adicional debajo de los asientos de la segunda fila. Los asientos se levantan y te ofrecen un lugar para guardar herramientas o elementos pequeños.',
							Image: require('./../assets/Galerias/06_BroncoBB/01_Bullets/bullet1.webp'),
						},
						{
							Position: '-2.878 0.329 -2.190',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '9 Airbags pensados en la seguridad tuya y la de todos los pasajeros, incluimos 9 airbags que dan tranquilidad a la hora de conducir. La Nueva Bronco Sport 4x4 se destaca en seguridad con sus airbags frontales y laterales para conductor y pasajero, de rodilla para conductor, de cortina y laterales en las plazas traseras.',
							Image: require('./../assets/Galerias/06_BroncoBB/01_Bullets/bullet2.webp'),
						},
						{
							Position: '1.526 -0.353 -3.119',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asientos para tu comodidad. En la Nueva Bronco Sport 4x4 el placer de conducir es único. Además del sistema de calefacción en los asientos delanteros, la plaza del conductor posee ajuste eléctrico. *Disponible en la versión Wildtrak 4x4.',
							Image: require('./../assets/Galerias/06_BroncoBB/01_Bullets/bullet3.webp'),
						},
						{
							Position: '-2.917 0.470 -0.017',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'SYNC 3.4 con pantalla táctil. A través de sencillos comandos de voz, el sistema de conectividad SYNC 3.4 te permitirá controlar tu música y realizar llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil multi-capacitiva de  8 pulgadas y un sistema de audio premium Bang & Olufsen con 10 parlantes en la versión Wildtrak 4x4. ',
							Image: require('./../assets/Galerias/06_BroncoBB/01_Bullets/bullet4.webp'),
						},
						{
							Position: '-2.917 0.423 1.805',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Pantalla de productividad. La Nueva Bronco Sport 4x4 ostenta una pantalla de productividad de 6.5' en el tablero de instrumentos, permitiéndote visualizar toda la información de la computadora de viaje y más.",
							Image: require('./../assets/Galerias/06_BroncoBB/01_Bullets/bullet5.webp'),
						},
					],
				},
				'BRONCO SPORT OUTER BANKS': {
					Image: require('./../assets/360/Interiors/29-Bronco Sport Black Diamond.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '1.526 2.815 -0.100',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Almacenamiento Inteligente. Si necesitas más espacio de almacenamiento, la versión Wildtrak ofrece espacio adicional debajo de los asientos de la segunda fila. Los asientos se levantan y te ofrecen un lugar para guardar herramientas o elementos pequeños.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet01.webp'),
						},
						{
							Position: '-2.878 0.329 -2.190',
							Rotation: '-57.661 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '9 Airbags pensados en la seguridad tuya y la de todos los pasajeros, incluimos 9 airbags que dan tranquilidad a la hora de conducir. La Bronco Sport 4x4 se destaca en seguridad con sus airbags frontales y laterales para conductor y pasajero, de rodilla para conductor, de cortina y laterales en las plazas traseras.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet02.webp'),
						},
						{
							Position: '-2.917 -0.806 -0.017',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asientos para tu comodidad. En la Nueva Bronco Sport 4x4 el placer de conducir es único. Además del sistema de calefacción en los asientos delanteros, la plaza del conductor posee ajuste eléctrico. *Disponible en la versión Wildtrak 4x4.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet05.webp'),
						},
						{
							Position: '-2.917 0.470 -0.017',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'SYNC 3.4 con pantalla táctil. A través de sencillos comandos de voz, el sistema de conectividad SYNC 3.4 te permitirá controlar tu música y realizar llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil multi-capacitiva de  8 pulgadas y un sistema de audio premium Bang & Olufsen con 10 parlantes en la versión Wildtrak 4x4. ',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet04.webp'),
						},
						{
							Position: '-2.917 0.423 1.805',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Pantalla de Productividad. La Bronco Sport 4x4 ostenta una pantalla de productividad de 6.5 en el tablero de instrumentos, permitiéndote visualizar toda la información de la computadora de viaje y más.",
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet01.webp'),
						},
					],
				},
				'EDGE SEL': {
					Image: require('./../assets/360/Interiors/07-EdgeSEL.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.470 -0.017',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Nuevo sistema de conectividad SYNC® 4A con pantalla táctil de 12' Conviertiéndose en uno de los mejores sistemas de info-entretenimiento del mercado, el nuevo SYNC 4A brinda posibilidades de conectividad inimaginables. Además de contar con una interfaz dos veces más rápida, comandos de voz más robustos para controlar tu celular, el entretenimiento, compatibilidad inhalámbrica con Android Auto y Apple CarPlay y más, incorpora inteligencia artificial para adaptarse a tu rutina y hacer de cada viaje una experiencia de otro nivel. *Imagen de referencia de la versión Titanium, la cual no se comercializa en Colombia.",
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.878 -1.714 0.223',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Ahora no necesitas de cables para cargar tu celular. En caso que tu teléfono cuente con la tecnología de carga inalámbrica, solo deberás colocarlo encima de la base de carga de la Edge.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/BUllet 02.webp'),
						},
						{
							Position: '-2.917 -0.564 -0.003',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La cámara de marcha atrás ofrece una imagen de video en la pantalla de la consola central del área detrás de tu vehículo, incluyendo guías de referencia. Complementando, la  Edge también cuenta con sensores de proximidad traseros. Imagen de referencia de la versión Titanium, la cual no se comercializa en Colombia.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.778 -2.239 0.313',
							Rotation: '-45 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Nueva transmisión automática de 8 velocidades, controlada a través de un sofisticado selector de marchas giratorio que reemplaza la tradicional palanca de cambios, brindando así mayor amplitud y sofisticación en el habitáculo.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 1.536 -0.003',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Un espejo que se acomoda a la situación para tu comodidad y seguridad, representando el dinamismo y capacidad de adaptarse al cambio. Este se oscurece automáticamente para evitar que las molestas luces traseras te encandilen.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '2.917 2.559 0.313',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre. Imágenes de referencia. El color del tapizado de los asientos es negro.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EDGE ST': {
					Image: require('./../assets/360/Interiors/08-EdgeST.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '1.023 -0.006 -2.125',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asientos para tu comodidad, en la  Edge ST el placer de conducir es único. Además del sistema de calefacción y ventilación en los asientos delanteros, posee ajuste eléctrico. Adicionalmente, la banca trasera también cuenta con sistema de calefacción.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.137 -1.649 0.313',
							Rotation: '-90 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Cuenta con una nueva transmisión automática de alto desempeño con 7 velocidades, controlada a través de levas de cambio en el volante o un sofisticado selector de marchas giratorio que reemplaza la tradicional palanca de cambios, brindando así mayor amplitud y sofisticación en el habitáculo.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 -1.054 -0.003',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Permite controlar la calefacción y refrigeración indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor y el pasajero. Puede regularse mediante comandos de voz, a través de la pantalla táctil o desde los comandos en el panel central.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.778 -0.219 -0.003',
							Rotation: '-0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La cámara de marcha atrás ofrece una imagen de video en la pantalla de la consola central del área detrás de tu vehículo, incluyendo guías de referencia. Complementando, la  Edge también cuenta con sensores de proximidad traseros. Imagen de referencia de la versión Titanium, la cual no se comercializa en Colombia.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 -0.387 0.679',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El sistema de acceso sin llave detecta la presencia del control remoto cuando está cerca de la Edge ST, permitiéndote ingresar al vehículo sin necesidad de sacarlo del bolsillo. Una vez que el control remoto se encuentra dentro del vehículo, podrás encender el motor con solo pulsar un botón.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '2.917 2.559 0.313',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre. Imágenes de referencia. El color del tapizado de los asientos es negro.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EXPLORER XLT': {
					Image: require('./../assets/360/Interiors/09-ExplorerXLT.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '4.111 0.661 0.146',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Máxima comodidad. La Nueva Explorer cuenta con 3 filas de asientos, que permiten acomodar generosamente hasta 7 pasajeros.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.137 0.465 0.480',
							Rotation: '-90 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El sistema de acceso sin llave detecta la presencia del control remoto cuando está cerca de la nueva Ford Explorer, permitiéndote ingresar al vehículo sin necesidad de sacarlo del bolsillo. Una vez que el control remoto se encuentra dentro del vehículo, podrás encender el motor con solo pulsar un botón.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 0.246 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Sistema de conectividad SYNC 3.4 con pantalla táctil de 8'. El sistema de conectividad SYNC 3 te permitirá controlar la música y realizar llamadas, sin quitar las manos del volante. En la Ford Explorer XLT 4x4 la experiencia a bordo es única. ",
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.778 -0.219 -0.003',
							Rotation: '-0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Climatizador electrónico de tres zonas. Permite controlar la calefacción (versiones XLT y Limited) y ventilación (versión Limited), indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor, el pasajero delantero y la segunda fila.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '2.917 2.559 0.313',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre. Imágenes de referencia. El color del tapizado de los asientos es negro con costuras grises. ',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '-1.542 -0.508 0.197',
							Rotation: '-90 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Nueva transmisión automática inteligente de 10 velocidades, controlada a través de un sofisticado selector de marchas giratorio que reemplaza la tradicional palanca de cambios, brindando así mayor facilidad al momento de operar la transmisión, además de más amplitud y sofisticación en el habitáculo.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EXPLORER LIMITED': {
					Image: require('./../assets/360/Interiors/10-ExplorerLimited.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '4.111 0.661 0.146',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Máxima comodidad. La Nueva Explorer cuenta con 3 filas de asientos, que permiten acomodar generosamente hasta 7 pasajeros.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-1.990 0.465 0.534',
							Rotation: '-90 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El sistema de acceso sin llave detecta la presencia del control remoto cuando está cerca de la nueva Ford Explorer, permitiéndote ingresar al vehículo sin necesidad de sacarlo del bolsillo. Una vez que el control remoto se encuentra dentro del vehículo, podrás encender el motor con solo pulsar un botón.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 0.441 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Sistema de conectividad SYNC 3.4 con pantalla táctil de 8'. El sistema de conectividad SYNC 3 te permitirá controlar la música y realizar llamadas, sin quitar las manos del volante. En la Ford Explorer XLT 4x4 la experiencia a bordo es única. ",
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.778 -0.400 -0.003',
							Rotation: '-0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Climatizador electrónico de tres zonas. Permite controlar la calefacción (versiones XLT y Limited) y ventilación (versión Limited), indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor, el pasajero delantero y la segunda fila.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '2.917 2.559 0.313',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre. Imágenes de referencia. El color del tapizado de los asientos es negro con costuras grises. ',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'EXPLORER ST': {
					Image: require('./../assets/360/Interiors/11-ExplorerST.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.441 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "SYNC 3.4 con pantalla táctil de 10.1'. A tráves de sencillos comandos de voz, el sistema de conectividad SYNC 3.4 te permitirá controlar tu música y realizar llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una enorme pantalla vertical táctil multi-capacitiva de  10.1 pulgadas y un sistema de audio premium Bang & Olufsen de 980 Watts con 14 parlantes. En la Nueva Explorer ST la experiencia a bordo es única. Imágenes de referencia que no corresponden a la Explorer ST comercializada en Colombia.",
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.917 0.012 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La cámara de 360 grados disponible con pantalla dividida 10 usa cuatro cámaras (una en la parrilla, puerta trasera levadiza y debajo de cada espejo lateral), para permitirte ver alrededor del vehículo en la pantalla central. Es muy útil especialmente cuando maniobras en espacios reducidos o en senderos.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 0.553 1.683',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La Nueva Explorer ST ostenta un tablero de instrumentos de 12.3' a color completamente digital y personalizable, permitiéndote visualizar toda la información de la computadora de viaje, el comportamiento del sistema AWD, las asistencias al conductor y mucho más",
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 1.799 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Un espejo que se acomoda a la situación para tu comodidad y seguridad, representando el dinamismo y capacidad de adaptarse al cambio. Este se oscurece automáticamente para evitar que las molestas luces traseras te encandilen. *Imágenes de referencia que no corresponden a la Explorer ST comercializada en Colombia.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/fco-edge-ride-galeria-interior-3.webp'),
						},
						{
							Position: '3.384 0.553 -0.189',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'En la Nueva Explorer ST el placer de conducir es único. Además del sistema de calefacción y ventilación en los asientos delanteros microperforados y con el emblema ST, posee ajuste eléctrico (asiento conductor).',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'EXPEDITION LIMITED': {
					Image: require('./../assets/360/Interiors/12-ExpeditionLimited.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.012 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Sistema de conectividad SYNC® 3 con pantalla táctil A tráves de simples comandos de voz, controla tu música y realiza llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil de 8 pulgadas y un sistema de audio premium Bang & Olufsen con 12 parlantes. En la Nueva Expedition la experiencia a bordo es única.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-2.917 -0.757 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Climatizador electrónico de triple  zona. Permite controlar la calefacción y refrigeración, indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor, el pasajero delantero y las plazas de la segunda fila.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '0.896 0.467 1.838',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'En la Nueva Expedition el placer es único. Además del sistema de ventilación en los asientos delanteros y el sistema de calefacción en los asientos delanteros y traseros de la segunda fila, posee ajuste eléctrico de 10 vías (asiento conductor y pasajero delantero). Los asientos de la segunda fila son independientes (sillas de capitán), propios de un ejecutivo.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '2.150 1.143 -3.538',
							Rotation: '0 -45 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Pantallas de DVD. En la Nueva Expedition todos viajan en primera clase. Dos pantallas de entretenimiento ubicadas en el respaldo de los apoyabezas de los asientos delanteros harán hacen de esos viajes largos, más divertidos y entretenidos para los pasajeros de atrás.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '3.384 2.485 -0.189',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Techo panorámico de doble panel. La elegancia y deportividad del diseño se pueden ver en todas partes. El techo panorámico de doble panel genera una experiencia a bordo incomparable. Ya sea que te sientes adelante o atrás, el techo panorámico te permite contemplar el cielo y sentirte libre.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'RANGER XL': {
					Image: require('./../assets/360/Interiors/16-RangerXL-BG.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.344 -1.916',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Nueva Ranger XL Diesel 4x4, es referencia en términos de seguridad. Son de norma en la gama los frenos con ABS y EBD en las cuatro ruedas, el control de descenso (HDC), el control antivuelco (ROM), el control electrónico de estabilidad (ESC) y tracción (TCS), el control de carga adaptativo (LAC), el control de balanceo de tráiler (TSM); y tres airbags incluyendo el de rodillas para el conductor',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet01.webp'),
						},
						{
							Position: '-2.917 -1.293 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Nueva Ranger XL Diesel 4x4, utiliza una caja de transferencia 4x4 robusta y bien probada para acoplar y trabar los ejes delanteros y traseros al seleccionar la conexión 4x4. El conductor puede cambiar de 4x2 a 4x4 alta en cualquier momento sin necesidad de detener el vehículo, por medio del comando electrónico posicionado ergonómicamente en la consola central “Shift on the Fly” (ESOF)',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet02.webp'),
						},
						{
							Position: '-2.917 -0.048 2.393',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La nueva Ford Ranger XL Diesel 4x4 equipa una Dirección Asistida Eléctrica, la cual proporciona una asistencia variable basada en la velocidad y las fuerzas laterales. A bajas velocidades, ofrece más suavidad para una mayor maniobrabilidad. A velocidades altas, la asistencia disminuye y la dirección se endurece para obtener más control del vehículo. Este sistema permite filtrar vibraciones introducidas por las irregularidades del camino. legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet03.webp'),
						},
						{
							Position: '-2.917 -0.754 2.290',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'En materia de airbags, la nueva Ford Ranger XL Diesel 4x4 está equipada, con 3 airbags (frontales más airbag de rodilla del conductor)',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet04.webp'),
						},
						{
							Position: '0.896 0.467 1.838',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asiento del conductor con ajuste manual de 4 direcciones.',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet05.webp'),
						},
					],
				},
				'RANGER XLS DIESEL': {
					Image: require('./../assets/360/Interiors/17-RangerXLS-Diesel.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.179 -0.298',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La Ranger XLS Diesel MT 4x4 ahora viene equipada con una nueva pantalla táctil de 8' y sistema de conectividad Sync® 2.5. A través de esta pantalla podras controlar de manera intuitiva varias funciones. Compatible con Apple Car Play y Android Auto. Disponible en las versiones XLS Gasolina y Diesel",
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet01.webp'),
						},
						{
							Position: '-2.917 0.179 0.298',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Una forma más inteligente y segura de usar tu celular mientras conduces. Varias funciones y aplicaciones de tu celular, incluyendo Waze, aparecerán en la pantalla de 8' de la Ranger gracias a Apple CarPlay y Android Auto. La activación del sistema de navegación Waze depende de la marca/versión de tu teléfono celular. Disponible en las versiones Ranger XLS Gasolina y Diesel XLT y Ranger Limited",
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet02.webp'),
						},
						{
							Position: '0.818 -0.123 2.863',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asiento al conductor con ajuste manual de 6 direcciones. ',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet03.webp'),
						},
						{
							Position: '-2.917 -0.241 2.803',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Volante multi- funcional con controles de velocidad, audio y teléfono. ',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet04.webp'),
						},
						{
							Position: '-2.917 0.552 1.731',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Tablero de instrumentos con pantalla TFT. 1 Pantalla de 4'",
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet05.webp'),
						},
					],
				},
				'F-150 LARIAT SPORT': {
					Image: require('./../assets/360/Interiors/21-LariatSport.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.179 -0.113',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '¡Una mezcla entre la comodidad de la casa y oficina, pero en el camino !El interior está completamente rediseñado para elevar la experiencia de los propietarios de Pick-Ups con estilo, comodidad, funcionalidad y tecnología. *Imágenes de referencia. Algunas imágenes o características, varían con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '0.818 -0.123 2.863',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Los detalles predominan en todas partes, los asientos vienen tapizados con cuero (material principal) en dos tonos y costuras contrastantes, estos varían en función a la versión. Así mismo, los paneles de las puertas guardan concordancia con los materiales y tonalidades de los asientos.  Los contornos del asiento y el material del cojín están diseñados para reducir los puntos de presión. *Imágenes de referencia. Algunas imágenes o características, varían con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 02.webp'),
						},
						{
							Position: '-2.917 0.552 1.731',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La F-150 equipa un volante con nuevo diseño especÍfico para cada versión, viene forrado con cuero y  permite  ajustarse, tanto en altura como en profundidad. *Imágenes de referencia. Algunas imágenes o características, varían con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 -0.241 2.803',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Los pedales, los espejos exteriores y el asiento del conductor se ajustan de forma eléctrica y cuentan con hasta 3 memorias para guardar las posiciones de cada conductor de la Ford F-150. *Imágenes de referencia. Algunas imágenes o características, varían con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 0.627 -0.113',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Con la Ford F-150 se introduce a Colombia la nueva generación del sistema de entretenimiento y comunicaciones, SYNC® 4. La tecnología SYNC® 4 es la versión más inteligente de SYNC® hasta la fecha, diseñada para saber qué necesitan los clientes cuando lo necesitan. SYNC® 4, viene a Colombia con una pantalla táctil 12" ubicada de forma horizontal que brinda un equilibrio entre las demandas de la accesibilidad tecnológica y la mayor comodidad de los botones físicos. *Imágenes de referencia. Algunas imágenes o características, varían con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 05.webp'),
						},
						{
							Position: '-2.917 1.102 2.528',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Ford F-150 incorpora una pantalla LCD de productividad de 12" totalmente digital con gráficos y animaciones a color que responden a los modos de conducción seleccionables del vehículo. Adicionalmente, muestra datos e información para el manejo Off-Road, todo esto para mantener informado al conductor. *Imágenes de referencia. Algunas imágenes o características, varían con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'F-150 XLT FHEV': {
					Image: require('./../assets/360/Interiors/F150XLT.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.113 0.758',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Retroceder un remolque implica dirigir dos vehículos a la vez, la camioneta hacia una dirección y el remolque en la dirección opuesta. No importa si eres un novato o un profesional experimentado en esta difícil maniobra, con la Nueva Ford F-150 XLT Completamente Híbrida y el Pro Trailer Backup Assist™ disponible hace que sea tan fácil como girar una perilla. Una vez que ingresas algunas medidas en el sistema, la cámara detecta la posición del remolque mientras retrocedes y guías al remolque. Simplemente gira la perilla hacia la izquierda o la derecha según la dirección que deseas que vaya el remolque mientras el sistema controla el volante.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/6.webp'),
						},
						{
							Position: '0.818 -0.123 2.863',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Asientos para tu comodidad. Los detalles predominan en todas partes, los asientos vienen tapizados con tela. Así mismo, los paneles de las puertas guardan concordancia con los materiales y tonalidades de los asientos. Los contornos del asiento y el material del cojín están diseñados para reducir los puntos de presión.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/2.webp'),
						},
						{
							Position: '-2.917 0.552 3.067',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Diseño del Volante La Nueva Ford F-150 XLT Completamente Híbrida equipa un volante con diseño nuevo, viene forrado con cuero y permite ajustarse, tanto en altura como en profundidad.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/3.webp'),
						},
						{
							Position: '-0.668 -1.325 -0.113',
							Rotation: '90 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '¡Más Almacenamiento! La consola central provee varias soluciones de almacenamiento rápido para teléfonos móviles, bolígrafos, tarjetas de presentación, portavasos, entre otros. *Imágenes de referencia. La combinación de colores de la tapicería de la imagen no se comercializa en Colombia.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/4.webp'),
						},
						{
							Position: '-2.917 -0.143 1.897',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '7 Modos de Manejob La Nueva F-150 Completamente Híbrida en sus versiones XLT y Platinum, incorpora 7 modos de manejo: Normal, ECO, Sport, Remolcar/Arrastrar, Resbaladizo, Nieve/Arena y Barro. Con la pantalla de productividad personalizable, estos crean un ambiente interior acorde a tu acción.  Los modos de manejo seleccionables le ayudarán al conductor a mantener el control en una variedad de terrenos y en condiciones no favorables. ',
							Image: require('./../assets/Galerias/F150XLT/Bullet/12.webp'),
						},
						{
							Position: '-2.917 0.627 -0.113',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "La Ford F-150 XLT Completamente Híbrida, introduce la nueva generación del sistema de entretenimiento y comunicaciones SYNC®4. Este sistema, brinda nuevos niveles de inteligencia, para lograr una interacción más rápida con el usuario, así como una conexión del vehículo con el smartphone mucho más sencilla. Adicional, contiene manual de propietario digital en la pantalla para mayor facilidad del usuario. * El manual de propietario digital que incluye el SYNC®4, está realizada para el mercado de Sudamérica, por cuanto Ford Colombia le entregará al cliente la versión del manual adaptada al país física",
							Image: require('./../assets/Galerias/F150XLT/Bullet/5.webp'),
						},
						{
							Position: '0.818 -0.123 -2.068',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'El diseño Interior de la F-150 XLT Completamente Híbrida es una mezcla entre la comodidad de la casa y oficina, pero en el camino. El interior está completamente rediseñado para elevar la experiencia de los propietarios de pick ups con estilo, comodidad, funcionalidad y tecnología. ',
							Image: require('./../assets/Galerias/F150XLT/Bullet/1.webp'),
						},
						{
							Position: '4.467 -2.361 -0.063',
							Rotation: '11.880 -90 180.000',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'ALMACENAMIENTO PLEGABLE CON LLAVE La Nueva Ford F-150 Completamente Híbrida, en su segunda fila, dispone de un espacio de almacenamiento que proporciona un piso de carga prácticamente plano. Así mismo, cuando se necesite tener elementos bajo llave, este es el lugar adecuado, está integrado con el piso y es ideal para guardar artículos sueltos o cualquier objeto que requiera estar oculto y seguro.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/13.webp'),
						},
					],
				},
				'F-150 PLATINUM FHEV': {
					Image: require('./../assets/360/Interiors/22._F-150_Platinum.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [

						{
							Position: '-2.917 0.552 3.067',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El volante de la Ford F-150 Platinum,  cuenta con un sistema de calefacción, ideal para enfrentar las bajas temperaturas. Adicionalmente, este puede ajustarse, tanto en altura como en profundidad, de forma eléctrica. Incluye función de memoria  para almacenar hasta 3 diferentes posiciones.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/3.webp'),
						},
						{
							Position: '-0.668 -1.325 -0.113',
							Rotation: '90 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: '¡Más Almacenamiento! La consola central provee varias soluciones de almacenamiento rápido para teléfonos móviles, bolígrafos, tarjetas de presentación, portavasos, entre otros. *Imágenes de referencia. La combinación de colores de la tapicería de la imagen no se comercializa en Colombia.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/4.webp'),
						},
						{
							Position: '-2.917 -0.143 1.897',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El diseño de la F-150 Platinum Completamente Híbrida lleva a sus ocupantes a un nivel de confort y estilo superior.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/1.webp'),
						},
						{
							Position: '0.818 -0.123 -2.068',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'El nivel de calefacción o refrigeración de los asientos delanteros se puede ajustar para obtener la temperatura deseada, independiente para el conductor y pasajero. Los asientos traseros incorporan el sistema de calefacción para comodidad de los pasajeros en situaciones de temperaturas bajas. *Imágenes de referencia. Algunas características pueden variar con respecto al producto comercializado en Colombia.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/2.webp'),
						},
						{
							Position: '2.837 4.372 -0.255',
							Rotation: '-61.853 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'TECHO PANORÁMICO DE DOBLE PANEL La Nueva F-150 Platinum Completamente Híbrida incorpora un techo panorámico de doble panel, que le agrega mucha más luz al interior y una mayor sensación de libertad.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/11.webp'),
						}
					],
				},
				'RANGER RAPTOR': {
					Image: require('./../assets/360/Interiors/20-RangerRaptor.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '0.818 -0.123 2.863',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'Exclusivos asientos delanteros y traseros Raptor deportivos, completamente nuevos, inspirados en aviones de combate, con contorno corporal y costuras en tono código naranja. Las plazas delanteras cuentan con ajuste eléctrico de 10 vías, incluido ajuste lumbar y calefacción. La parte trasera cuenta con apoyabrazos, portavasos y habitáculo amplio debajo de los asientos para llevar cualquier tipo de objeto.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/BUllet 02.webp'),
						},
						{
							Position: '6.259 -0.123 1.710',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'En materia de equipamiento interior y confort, la Nueva Ranger Raptor™, continúa enfatizando el desempeño todoterreno y la naturaleza de alta energía del exterior, con un exclusivo diseño deportivo, acompañado de tecnología de avanzada.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '-4.448 -0.423 3.426',
							Rotation: '-32.151 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'En materia de equipamiento interior y confort, la Nueva Ranger Raptor™, continúa enfatizando el desempeño todoterreno y la naturaleza de alta energía del exterior, con un exclusivo diseño deportivo, acompañado de tecnología de avanzada.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-1.513 -2.029 -0.203',
							Rotation: '90 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'En materia de equipamiento interior y confort, la Nueva Ranger Raptor™, continúa enfatizando el desempeño todoterreno y la naturaleza de alta energía del exterior, con un exclusivo diseño deportivo, acompañado de tecnología de avanzada.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-4.448 -0.423 0.146',
							Rotation: '-32.151 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: 'La Nueva Ranger Raptor™ cuenta con un sistema de tracción 4x4 que permite contar con 4 modos de uso. 4x2, donde la Pick- Up funciona con tracción trasera; un modo 4x4 alta que reparte la fuerza del motor 50:50 entre el eje delantero y trasero; un modo 4x4 baja, que cuenta con caja reductora que multiplica por casi tres veces la fuerza en las ruedas y como novedad incorpora un modo 4x4 Automática, donde la  Pick- Up funciona en modo 4x4 según sea necesario y pasa a ser un vehículo AWD o de tracción permanente. ',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 05.webp'),
						},
					],
				},
				'F-150 RAPTOR': {
					Image: require('./../assets/360/Interiors/23-F-150RAptor.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 -0.387 2.488',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Ford F-150 Raptor equipa un volante revestido en cuero perforado con diseño exclusivo Raptor, incluye costuras en tono contrastante y una franja distintiva en la parte superior de la rueda, que le permitirá monitorear la dirección de las llantas al derrapar y tomar curvas. Cuenta con ajuste tanto en altura como en profundidad de forma eléctrica y memorias de posición. También incorpora levas en la parte posterior del volante, permitiendo al conductor poder hacer cambios rápidamente, brindando una sensación de manejo mucho más deportiva, sin levantar las manos del volante.',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 01.webp'),
						},
						{
							Position: '0.818 -0.123 2.863',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Type: "INTERIOR",
							Text: "Los asientos delanteros deportivos exclusivos Raptor están diseñados para atender las necesidades de conducción tanto en todoterreno como en carretera. Forrados en cuero con insertos de tela premium y el emblema 'Raptor' ubicado en el espaldar de las sillas delanteras. Cuenta con ajuste eléctrico de hasta 10 posiciones para el conductor, multiajustable para el pasajero y con sistema de calefacción y refrigeración. Los asientos traseros incorporan un sistema de calefacción para comodidad de los pasajeros en situaciones de temperaturas bajas.",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/BUllet 02.webp'),
						},
						{
							Position: '-2.917 2.291 -0.113',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Para aquellos que buscan darle un toque personal a su Ford F-150 Raptor, el vehículo cuenta con un panel de interruptores auxiliares en el techo de 6 posiciones instalado en fábrica, dedicado al control de los componentes auxiliares y accesorios, tales como luces para todoterreno, compresores de aire o cualquier otro accesorio que necesite energía. Cada interruptor se puede conectar para alimentar un sistema separado. Uno de los interruptores viene preconfigurado para encender y apagar las nuevas exploradoras todoterreno Rigid™.',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 03.webp'),
						},
						{
							Position: '-2.917 -0.646 1.656',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Los pedales, los espejos exteriores, el volante y el asiento del conductor se ajustan de forma eléctrica y cuentan con hasta 3 memorias para guardar las posiciones de cada conductor de la Ford F-150 Raptor',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 04.webp'),
						},
						{
							Position: '-2.917 0.057 -0.167',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Una vez dentro de la Ford F-150 Raptor, se podrá apreciar el nuevo interior centrado en el conductor con volante forrado en cuero con levas para control de cambio y marcador central. Asientos deportivos oscuros forrados en cuero, pantalla de productividad de 12.4' totalmente digital del grupo de instrumentos y una pantalla táctil de 12' ubicada en el panel central. Por supuesto, la Ford F-150 Raptor incluye seis interruptores auxiliares integrados que están listos para operar accesorios todoterreno, como iluminación LED adicional.",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/BUllet 05.webp'),
						},
					],
				},
				'RANGER FX4': {
					Image: require('./../assets/360/Interiors/25-Ranger-Fx4-Blanca.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '1.291 -0.101 1.778',
							Rotation: '18.151 54.940 23.937',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'En lo que respecta al diseño interior, la nueva Ranger FX4, además de ofrecer aplique negro en el panel, cuenta con asientos tapizados con cuero sintético con costuras rojas y el logo característico FX4: una estética exclusiva dentro de la familia Ranger. ',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/1.webp'),
						},
						{
							Position: '-2.917 0.124 0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Sistema de conectividad Sync® 3.4 con pantalla táctil. A tráves de simples comandos de voz, controla tu música y realiza llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil de 8 pulgadas.',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/1.webp'),
						},
						{
							Position: '-2.917 -0.101 2.389',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El volante de la Nueva Ranger FX4 cuenta con costuras rojas y un diseño deportivo.',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/1.webp'),
						},
					],
				},
				'RANGER LIMITED': {
					Image: require('./../assets/360/Interiors/InterioresActualizacionDiciembre/19 Ranger Limited.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.332 -0.312',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Sistema de conectividad Sync® 3 con pantalla táctil A tráves de simples comandos de voz, controla tu música y realiza llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil de 8 pulgadas. Disponible en las versiones Ranger XLT y Ranger Limited.',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/1.webp'),
						},
						{
							Position: '-2.917 -0.101 2.389',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La seguridad es primordial. 7 Airbags, pensando en la seguridad tuya y de tu familia, incluímos 7 airbags que dan tranquilidad a la hora de conducir. La Ford Ranger se destaca en seguridad, con sus airbags frontales, de rodilla para conductor, airbags de cortina y laterales de tórax. Disponible en las versiones XLT y Limited',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/2.webp'),
						},
						{
							Position: '-2.917 -0.677 0.012',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Climatizador electrónico de doble zona. Permite controlar la calefacción y refrigeración indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor y el pasajero. Puede regularse mediante comandos de voz, a través de la pantalla táctil o desde los comandos en el panel central. Disponible en las versiones Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/3.webp'),
						},
						{
							Position: '1.131 -0.074 1.541',
							Rotation: '0 49.235 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Asientos para tu comodidad . En la Ranger el placer de conducir es único. Los asientos vienen tapizados con cuero sintético. Adicionalmente, la plaza del conductor cuenta con ajuste eléctrico de 6 vías más ajuste lumbar manual. Disponible en la versión Ranger Limited.',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/4.webp'),
						},
						{
							Position: '-2.917 0.340 0.199',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La cámara de marcha atrás ofrece una imagen de video en la pantalla de la consola central del área detrás de tu vehículo, incluyendo guías de referencia. Complementando, la Ranger también cuenta con sensores de proximidad delanteros y traseros. Disponible en la versión Ranger Limited',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/5.webp'),
						},
						{
							Position: '-2.917 2.104 -0.028',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Retrovisor interior electrocrómico. Un espejo que se acomoda a la situación para tu comodidad y seguridad, representando el dinamismo y capacidad de adaptarse al cambio. Este se oscurece automáticamente para evitar que las molestas luces traseras te encandilen. Disponible en las versiones Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/8.webp'),
						}
					],
				},
				'RANGER XL CHASIS': {
					Image: require('./../assets/360/Interiors/InterioresActualizacionDiciembre/15 Ranger XL Chasis.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 -3.073 -0.001',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La Nueva Ranger XL Chasis Diesel 4x4 también ostenta una capacidad off-road fuera de serie, ya que cuenta con una caja de transferencia electrónica 4x4 ESOF (Electronic Shift On the Fly)',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/1.webp'),
						},
						{
							Position: '-2.917 0.831 2.331',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Tecnologías de seguridad que mantienen a tu Nueva Ranger XL Chasis Diesel 4x4 bajo control incluso en maniobras bruscas, reduciendo el riesgo de accidentes. Incluye: - Control de carga adaptativo (LAC). - Advance Trac ®Control electrónico de estabilidad (ESC) y tracción (TCS). - Control de descenso (HDC). - Control antivuelco (ROM). - Control de balanceo de trailer (TSM). - Control de crucero con limitador electrónico de velocidad. - Frenos con ABS y EBD en las cuatro ruedas. - 3 airbags, 2 Frontales y 1 de rodillas para el conductor.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/2.webp'),
						},
						{
							Position: '-2.917 -0.516 -0.016',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones Ranger XL Chasis, XL Doble Cabina,  XLS Diesel, XLT y  Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/3.webp'),
						},
						{
							Position: '-2.917 -0.101 2.389',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Volante multi-funcional con controles de velocidad, audio y teléfono. ',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/4.webp'),
						},
						{
							Position: '-2.917 -1.250 -0.016',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Transmisión Manual de 6 velocidad.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/5.webp'),
						},
					],
				},
				'RANGER XLT': {
					Image: require('./../assets/360/Interiors/InterioresActualizacionDiciembre/18 Ranger XLT.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.332 -0.312',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Sistema de conectividad Sync® 3 con pantalla táctil A tráves de simples comandos de voz, controla tu música y realiza llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil de 8 pulgadas. Disponible en las versiones Ranger XLT y Ranger Limited.',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/1.webp'),
						},
						{
							Position: '-2.917 -0.101 2.389',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'La seguridad es primordial. 7 Airbags, pensando en la seguridad tuya y de tu familia, incluímos 7 airbags que dan tranquilidad a la hora de conducir. La Ford Ranger se destaca en seguridad, con sus airbags frontales, de rodilla para conductor, airbags de cortina y laterales de tórax. Disponible en las versiones XLT y Limited ',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/2.webp'),
						},
						{
							Position: '-2.917 -0.677 0.012',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Climatizador electrónico de doble zona. Permite controlar la calefacción y refrigeración indicando las temperaturas, la velocidad del ventilador y las salidas de aire deseadas, con la posibilidad de configurar diferentes valores para el conductor y el pasajero. Puede regularse mediante comandos de voz, a través de la pantalla táctil o desde los comandos en el panel central. Disponible en las versiones Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/3.webp'),
						},
						{
							Position: '-2.917 -0.074 1.541',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'El conductor puede cambiar de 4x2 a 4x4 alta en cualquier momento sin necesidad de detener el vehículo (hasta los 120 km/h) por medio del comando electrónico posicionado ergonómicamente en la consola central “Shift on the Fly”. También posee una 4x4 baja para ofrecer mayor torque a baja velocidad. Disponible en las versiones XL Chasis, XL Doble Cabina, XLS Diesel, XLT y Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/4.webp'),
						},
						{
							Position: '-2.917 0.340 0.199',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Apple CarPlay y Android Auto. Una forma más inteligente y segura de usar tu celular mientras conduces. Varias funciones y aplicaciones de tu celular, incluyendo Waze, aparecerán en la pantalla de 8" de la Ranger gracias a Apple CarPlay y Android Auto. La activación del sistema de nevagación Waze depende de la marca/versión de tu teléfono celular. Disponible en las versiones Ranger XLS Gasolina y Diesel XLT y Ranger Limited',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/5.webp'),
						},
						{
							Position: '-2.917 2.104 -0.028',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Retrovisor interior electrocrómico. Un espejo que se acomoda a la situación para tu comodidad y seguridad, representando el dinamismo y capacidad de adaptarse al cambio. Este se oscurece automáticamente para evitar que las molestas luces traseras te encandilen. Disponible en las versiones Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/8.webp'),
						},
					],
				},
				'RANGER LIMITED BLACK EDITION': {
					Image: require('./../assets/360/Interiors/InterioresActualizacionDiciembre/26 Ranger Limited Black Edition.webp'),
					Rotation: '0 90 0',
					BulletsInfo: [
						{
							Position: '-2.917 0.526 1.715',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: 'Asistenteanti-colisióncon detectorde peatones. Al detectar un posible riesgo de colisión con el vehículo de adelante o con un peatón que entra de improviso en la trayectoria, el sistema aplicará los frenos de forma automática para prevenir totalmente o reducir las consecuencias de un eventual choque.',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/3.webp'),
						},
						{
							Position: '-2.917 0.332 -0.312',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Type: "INTERIOR",
							Text: "Sistema de conectividad Sync® 3.4 con pantalla táctil. A tráves de simples comandos de voz, controla tu música y realiza llamadas, todo esto sin quitar las manos del volante. Este sistema viene acompañado de una pantalla táctil de 8 pulgadas.",
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/5.webp'),
						}
					],
				},
			},
		];
	},
};
